<!-- Breadcrumb End -->
<div class="el-breadcrumb-wrapper">
    <div class="container">
        <div class="el-breadcrmb-inner">
            <h1>checkout</h1>
            <ul>
                <li>

                    <a [routerLink]="['/cart']" style="color: #e04787;"><i class="fa fa-reply " aria-hidden="true"></i>
                        Back</a>

                </li>
            </ul>
        </div>
    </div>
</div>
<!-- Breadcrumb Start -->
<!-- Checkout Page -->
<div class="el-checkout-wrapper">
    <div class="container">
        <div class="row g-4">

            <div *ngIf="billingDetails.cartItems.length==0">
                <div class="wc-proceed-to-checkout text-center">
                    <a class="el-btn" [routerLink]="['/product']">Continue Shopping</a>
                </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 text-start" *ngIf="billingDetails.cartItems.length>0">
                <div class="woo-cart-table text-start" *ngIf="isNewBillingAddress">
                    <form class="checkout woocommerce-checkout" [formGroup]="addAddressForm"
                        (ngSubmit)="addNewAddress()">
                        <h3 class="checkout-heading">Add New Billing Address</h3>
                        <div class="row">
                            <div class="col-lg-12 col-md-6 col-sm-6 col-6">
                                <div class="el-input-field">
                                    <label>Full name <sup>*</sup></label>
                                    <input type="text" placeholder="" formControlName="username">
                                    <div class="text-danger"
                                        *ngIf="addAddressForm.get('username')?.touched && addAddressForm.get('username')?.invalid">
                                        <small *ngIf="addAddressForm.get('username')?.errors?.['required']">
                                            Full name is required
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-6">
                                <div class="el-input-field">
                                    <label>Your Email <sup>*</sup></label>
                                    <input class="secondary" type="text" placeholder="" formControlName="email"
                                        readonly>
                                    <div class="text-danger"
                                        *ngIf="addAddressForm.get('email')?.touched && addAddressForm.get('email')?.invalid">
                                        <small *ngIf="addAddressForm.get('email')?.errors?.['required']">
                                            Email is required
                                        </small>
                                        <small *ngIf="addAddressForm.get('email')?.errors?.['email']">
                                            Enter a valid email
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-6">
                                <div class="el-input-field">
                                    <label>Mobile No <sup>*</sup></label>
                                    <input type="text" placeholder="" formControlName="mobile">

                                    <div class="text-danger"
                                        *ngIf="addAddressForm.get('mobile')?.touched && addAddressForm.get('mobile')?.invalid">
                                        <small *ngIf="addAddressForm.get('mobile')?.errors?.['required']">
                                            Mobile number is required
                                        </small>
                                        <small *ngIf="addAddressForm.get('mobile')?.errors?.['pattern']">
                                            Enter a valid 10-digit mobile number
                                        </small>
                                    </div>
                                </div>
                            </div>


                            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                <div class="el-input-field el-checkout-input-dble">
                                    <label>Billing Address <sup>*</sup></label>
                                    <input type="text" placeholder="" formControlName="address">
                                    <div class="text-danger"
                                        *ngIf="addAddressForm.get('address')?.touched && addAddressForm.get('address')?.invalid">
                                        <small>Address is required</small>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-6">
                                <div class="el-input-field">
                                    <label>Postcode / Zip<sup>*</sup></label>
                                    <input type="text" placeholder="" formControlName="pin_code">
                                    <div class="text-danger"
                                        *ngIf="addAddressForm.get('pin_code')?.touched && addAddressForm.get('pin_code')?.invalid">
                                        <small *ngIf="addAddressForm.get('pin_code')?.errors?.['required']">
                                            Pincode is required
                                        </small>
                                        <small *ngIf="addAddressForm.get('pin_code')?.errors?.['pattern']">
                                            Enter a valid 6-digit pincode
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <div class="el-input-field">
                                    <label>Town / City <sup>*</sup></label>
                                    <input type="text" placeholder="" formControlName="city">
                                    <div class="text-danger"
                                        *ngIf="addAddressForm.get('city')?.touched && addAddressForm.get('city')?.invalid">
                                        <small>City is required</small>
                                    </div>
                                </div>
                            </div>


                            <!-- 
                            <div class="col-lg-6 col-md-6 col-sm-6 col-6">
                                <div class="el-input-field">
                                    <label>County / Region <sup>*</sup></label>
                                    <select id="country" #countrySel (change)="onCountryChange(countrySel.value)"formControlName="country">
                                        <option value="">-- Select Country --</option>
                                        <option *ngFor="let c of countries" [value]="c.countryId">{{ c.countryName }}                                          
                                        </option>
                                    </select>
                                </div>
                            </div>


                            <div class="col-lg-6 col-md-6 col-sm-6 col-6">
                                <div class="el-input-field">
                                    <label>State</label>
                                    <select id="state" formControlName="state">
                                        <option value="">-- Select State --</option>
                                        <option *ngFor="let s of states" [value]="s.stateId">
                                            {{ s.stateName }}
                                        </option>
                                    </select>
                                </div>
                            </div> -->

                            <div class="col-lg-6 col-md-6 col-sm-6 col-6">
                                <div class="el-input-field">
                                    <label>Country / Region <sup>*</sup></label>
                                    <select id="country" #countrySel (change)="onCountryChange(countrySel.value)"
                                        formControlName="country">
                                        <option value="">-- Select Country --</option>
                                        <option *ngFor="let c of countries" [value]="c.countryId">{{ c.countryName }}
                                        </option>
                                    </select>

                                    <div class="text-danger"
                                        *ngIf="addAddressForm.get('country')?.touched && addAddressForm.get('country')?.invalid">
                                        <small>Country is required</small>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-6 col-6">
                                <div class="el-input-field">
                                    <label>State</label>

                                    <!-- Agar India select ho to dropdown -->
                                    <select *ngIf="selectedCountryId === 1" id="state" formControlName="state">
                                        <option value="">-- Select State --</option>
                                        <option *ngFor="let s of states" [value]="s.stateId">
                                            {{ s.stateName }}
                                        </option>
                                    </select>

                                    <!-- Agar India nahi ho to textbox -->
                                    <input *ngIf="selectedCountryId !== 1" type="text" formControlName="state"
                                        placeholder="Enter State" />
                                </div>
                            </div>



                            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                <div class="d-flex justify-content-between">
                                    <button type="reset" class="el-btn"
                                        (click)="isNewBillingAddress=false;resetform()">Back</button>
                                    <button type="submit" class="el-btn">Save / Update
                                    </button>
                                </div>
                            </div>
                            <!-- [disabled]="addAddressForm.invalid" -->

                            <!-- State Dropdown -->

                        </div>
                    </form>

                </div>

                <div *ngIf="isNewBillingAddress ==false">
                    <div class="woo-cart-table text-start" *ngIf="isPayNow==false" style="margin-bottom: 20px;">
                        <div class="woocommerce-checkout-payment">
                            <h3><u>Billing address</u></h3>
                            <div class="payment_methods methods mt-5">



                                <div class="el-checkout-pymnt" *ngFor="let _obj of addressList; let i = index">
                                    <label class="el-para" [class.theme-color]="selectedAddressIndex === i">


                                        <table>

                                            <div class="d-flex justify-content-between">
                                                <div> <input type="radio" id="c2" name="selectedAddress" [value]="i"
                                                        [checked]="selectedAddressIndex === i"
                                                        (change)="selectAddress(i)" class="me-4" /></div>
                                                <div>
                                                    <span> {{ _obj.username }},</span>
                                                    <span> {{ _obj.address }},</span>
                                                    <span> {{ _obj.city }},</span>
                                                    <span>{{ _obj.state }},</span>
                                                    <span>{{ _obj.pinCode }},</span>
                                                    <span>{{ _obj.countryName }},</span>
                                                    <span> {{ _obj.mobile }},</span>
                                                    <span> {{ _obj.email }},</span>
                                                </div>
                                                <div> <a href="javascript:;"
                                                        (click)="editAddresh(_obj.id);isNewBillingAddress=true">
                                                        <i class="fas fa-edit ms-4"></i>
                                                    </a></div>

                                            </div>
                                        </table>
                                    </label>
                                    <hr>
                                </div>

                                <a class="el-btn" (click)="isNewBillingAddress=true">Add</a>
                            </div>
                        </div>
                    </div>


                    <div class="woo-cart-table text-start">
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>S.No.</th>
                                        <th>Discription</th>
                                        <th>quantity</th>
                                        <th>Rate</th>
                                        <th>Discount </th>
                                        <th>Subtotal</th>
                                        <th>GST</th>
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of billingDetails.cartItems; let i = index">
                                        <td>{{ i + 1 }}</td>
                                        <td>
                                            <div class="d-flex">
                                                <img class="card-img-top img-fluid rounded mx-auto d-block"
                                                    [src]="item.imageURL" alt="Book Image"
                                                    style="height: 140px; object-fit: cover;">
                                                {{ item.book_title }}
                                            </div>

                                        </td>

                                        <td>{{ item.quantity }}</td>
                                        <td>{{ item.unitPrice }}</td>
                                        <td>({{ item.discount }}%): {{ item.discountAmount |
                                            number:'1.2-2'}}
                                        </td>
                                        <td><i class="fas fa-rupee-sign"></i>&nbsp; {{
                                            item.unitPrice-item.discountAmount|
                                            number:'1.2-2'}}
                                        </td>
                                        <td>({{ item.gst }}%): {{ item.gstAmount|
                                            number:'1.2-2' }}</td>

                                        <td><i class="fas fa-rupee-sign"></i>&nbsp; {{
                                            item.unitPrice-item.discountAmount+item.gstAmount|
                                            number:'1.2-2' }}
                                        </td>

                                    </tr>


                                </tbody>


                            </table>
                        </div>
                    </div>
                    <div class="ed_cart_collaterals">
                        <div class="cart_totals">
                            <h2>Cart Totals</h2>
                            <table class="table table-bordered">
                                <tbody>

                                    <tr class="cart-subtotal">
                                        <th>Gross Amount</th>
                                        <td><span class="amount"><i class="fas fa-rupee-sign"></i>&nbsp; {{
                                                billingDetails.grossAmount | number: '1.2-2'}} </span></td>
                                    </tr>
                                    <tr class="cart-subtotal" *ngIf="billingDetails.discountAmount>0">
                                        <th>Discount Amount</th>
                                        <td><span class="amount"><i class="fa fa-minus"></i>&nbsp;<i
                                                    class="fas fa-rupee-sign"></i>&nbsp;{{billingDetails.discountAmount}}</span>
                                        </td>
                                    </tr>
                                    <tr class="cart-subtotal">
                                        <th>GST Amount</th>
                                        <td><span class="amount"><i class="fas fa-rupee-sign"></i>&nbsp; {{
                                                billingDetails.gstAmount | number: '1.2-2'}}</span></td>
                                    </tr>
                                    <tr class="order-total">
                                        <th>Net Amount</th>
                                        <td><span class="amount"><i class="fas fa-rupee-sign"></i>
                                            </span>&nbsp; {{billingDetails.netAmount | number: '1.2-2'}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="el-placeorder-btn">
                                <div class="d-flex justify-content-between" *ngIf="isPayNow==false">
                                    <a class="el-btn" [routerLink]="['/product']">Continue
                                        Shopping</a>
                                    <button type="button" class="el-btn" (click)="confirmOrder()">Proceed to
                                        Pay</button>
                                </div>

                                <button type="button" *ngIf="isPayNow" class="el-btn" (click)="payNow()">Pay
                                    Now</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>